













































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwFileUpload } from '@libs-uuif/shared/sw-file-upload';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
const cssPrefix = 'addpreffile';
@Component({
  components: {
    ...UUIFComponent,
    SwFileUpload,
    SwTextfield,
  },
})
export default class AddPrefFileDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @Prop()
  showAddPrefFileDialog: boolean;
  files:File[] = [];
  isErrorMessage:boolean = false;
  fileName: string  = '';
  errorMessage: string = '';
  description: string = '';
  @Watch('files')
  private onFileSelect() {
    if (this.files.length > 0) {
      this.isErrorMessage = false;
      this.fileName = this.files[0].name;
      if (this.fileName
              .toLowerCase()
              .split('.')
              .pop() !== 'exp') {
        this.isErrorMessage = true;
        this.errorMessage = 'Cannot process this file, Please choose the file of extension exp.';
      }
    }
  }
  mounted() {
    if ((this.$refs.addDescriptionRef as SwTextfield)) {
      (this.$refs.addDescriptionRef as SwTextfield).focus();
    }
  }
  uploadFile() {
    if (this.files.length > 0 && !this.isErrorMessage) {
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = (e: any) => {
        const request = {
          serialNumber: this.serialNumber,
          productID: this.productDetails.pID,
          fileName: this.fileName,
          fileContent: e.target.result,
          comments: this.description.trim(),
        };
        this.$store.dispatch('MswProductsStoreModule/addPrefFile', request)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            if (resp.operationStatus === 'OK') {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
              this.closeDialog(true);
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
            }
          })
          .catch((e: any) => {
            this.$store.commit('stopLoading');
            this.closeDialog();
            console.error(e);
          });
      };
    } else {
      this.isErrorMessage = true;
    }
  }
  closeDialog(value: boolean = false) {
    this.$emit('close-dialog', value);
  }
}
